import { createIcon } from './createIcon';

const Table = createIcon(
  'Table',
  <>
    <path d="M4 6H9.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 10H9.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 14H9.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4 18H9.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 6H20" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 10H20" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 14H20" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14.5 18H20" strokeLinecap="round" strokeLinejoin="round" />
  </>,
);

export default Table;
